import workspaceQuery from '../../../graphql/queries/product/EdataProductLightWorkspaceQuery.graphql';
import fragment from '../../../graphql/fragments/product/EdataProductLightFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const EdataProduct: EntityType & { enquiryUrl: string } = {
  type: 'EdataProductLight',
  title: 'Edata Product',
  formTitle: 'Edata Product',
  formUrl: '/Products/Edata/Product/',
  workspaceUrl: '/Products/Edata/ProductWorkspace/',
  enquiryUrl: '/Products/Edata/Enquiry/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'EDATA_PRODUCT',
};

export default EdataProduct;
